import React from 'react';
import { resolveIcon } from 'mayhem-icon-registry';

export default function RegisteredIcon({ value, context = 'dashboard', className = '', ...props }) {
    const icon = resolveIcon(value, context);
    if (!icon) return null;

    const style = icon.imageUrl
        ? { ...props.style, '--custom-icon-image': `url("${icon.imageUrl}")` }
        : props.style;

    return (
        <i
            {...props}
            aria-hidden={props['aria-hidden'] ?? true}
            className={`${icon.className} ${className}`.trim()}
            data-icon-text={icon.text || undefined}
            style={style}
        />
    );
}
